import { all } from 'redux-saga/effects';

import { authenticateUserWatcher, registerUserWatcher } from '../containers/login/Login.saga';

export default function* rootSaga() {
  yield all([authenticateUserWatcher(), registerUserWatcher()]);
}
